var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Header', {
    attrs: {
      "title": "團購一覽",
      "show-member-center": false,
      "logo": _vm.meta.header_image
    }
  }), _c('div', {
    staticClass: "s-p-3"
  }, _vm._l(_vm.groupBuyings, function (groupBuying) {
    return _c('HorizontalProductCard', {
      key: groupBuying.id,
      attrs: {
        "group-buying": groupBuying
      }
    });
  }), 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }